import { render, staticRenderFns } from "./BookmarksConfigurationSection.vue?vue&type=template&id=2a66c252&scoped=true"
import script from "./BookmarksConfigurationSection.vue?vue&type=script&lang=js"
export * from "./BookmarksConfigurationSection.vue?vue&type=script&lang=js"
import style0 from "./BookmarksConfigurationSection.vue?vue&type=style&index=0&id=2a66c252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66c252",
  null
  
)

export default component.exports